import { Helmet } from 'react-helmet-async';
import { usePageSeo } from '@/hooks/usePageSeo';

type PageSeoProps = {
  /** Sobrescreve o path da URL atual (ex.: path canónico estável). */
  path?: string;
};

/**
 * Injeta title, meta, canonical, OG/Twitter e JSON-LD para a rota pública.
 */
export function PageSeo({ path }: PageSeoProps = {}) {
  const { seo } = usePageSeo(path);

  if (!seo) return null;

  const robots = seo.robots?.content || 'index, follow';
  const schema = seo.schema;

  return (
    <Helmet>
      <title>{seo.title}</title>
      {seo.description ? <meta name="description" content={seo.description} /> : null}
      <meta name="robots" content={robots} />
      {seo.canonical ? <link rel="canonical" href={seo.canonical} /> : null}

      <meta property="og:title" content={seo.og.title} />
      <meta property="og:description" content={seo.og.description} />
      <meta property="og:type" content={seo.og.type || 'website'} />
      <meta property="og:site_name" content={seo.og.siteName} />
      {seo.canonical ? <meta property="og:url" content={seo.canonical} /> : null}
      {seo.og.image ? <meta property="og:image" content={seo.og.image} /> : null}

      <meta name="twitter:card" content={seo.twitter.card || 'summary_large_image'} />
      <meta name="twitter:title" content={seo.twitter.title} />
      <meta name="twitter:description" content={seo.twitter.description} />
      {seo.twitter.image ? <meta name="twitter:image" content={seo.twitter.image} /> : null}

      {schema && Object.keys(schema).length > 0 ? (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      ) : null}
    </Helmet>
  );
}
